// extracted by mini-css-extract-plugin
export var accountwrapper = "HeaderDesktop-module--accountwrapper--8d1a4";
export var basket = "HeaderDesktop-module--basket--435d1";
export var basketnotification = "HeaderDesktop-module--basketnotification--75dec";
export var basketscrolled = "HeaderDesktop-module--basketscrolled--8e81c";
export var bottomlinkswrapper = "HeaderDesktop-module--bottomlinkswrapper--2be61";
export var burgerwrapper = "HeaderDesktop-module--burgerwrapper--de6b8";
export var content = "HeaderDesktop-module--content--d6874";
export var contentrightwrapper = "HeaderDesktop-module--contentrightwrapper--74c99";
export var controlswrapper = "HeaderDesktop-module--controlswrapper--7eec0";
export var donatewrapper = "HeaderDesktop-module--donatewrapper--a78d9";
export var favs = "HeaderDesktop-module--favs--47de5";
export var favsscrolled = "HeaderDesktop-module--favsscrolled--8d24a";
export var headerinner = "HeaderDesktop-module--headerinner--3fd18";
export var headerouter = "HeaderDesktop-module--headerouter--e8942";
export var listlink = "HeaderDesktop-module--listlink--16cd2";
export var listlinkanchor = "HeaderDesktop-module--listlinkanchor--bf239";
export var listoflinks = "HeaderDesktop-module--listoflinks--d18e1";
export var logowrapperbottom = "HeaderDesktop-module--logowrapperbottom--9c904";
export var logowrappertop = "HeaderDesktop-module--logowrappertop--637bf";
export var primarylink = "HeaderDesktop-module--primarylink--96cfb";
export var primarylinks = "HeaderDesktop-module--primarylinks--57055";
export var searchbox = "HeaderDesktop-module--searchbox--eb805";
export var searchboxwrapper = "HeaderDesktop-module--searchboxwrapper--3ef3c";